import firebase from 'firebase';
import { contactUsResponsesActions } from './Reducers/ContactUsResReduer';
import { globalActionTypes } from './Reducers/GlobalReducer';
import { subsListActions } from './Reducers/SubsReducer';
//import { globleActionTypes } from './Reducers/globalActionTypes';

export const updateGlobal = (data) => {
    return firebase
        .firestore()
        .collection('globals')
        .doc('globals')
        .update(data);
};

export const deleteFile = (ref) => {
    var storageRef = firebase.storage().ref(ref);

    return storageRef.delete();
};

export const uploadFile = (ref, file) => {
    var storageRef = firebase.storage().ref(ref);

    return storageRef.put(file);
};

export const getGlobalData = (globalDispatch) => {
    return firebase
        .firestore()
        .collection('globals')
        .doc('globals')
        .onSnapshot({
            next: (doc) => {
                globalDispatch({
                    type: globalActionTypes.SET_GLOBAL_CAROUSEL,
                    globalCarousel: doc.data() ? doc.data().carousel || [] : []
                });
                globalDispatch({
                    type: globalActionTypes.SET_GLOBAL_LOADING,
                    globalLoading: false,
                });
                console.log(doc.data());
            }, error: (err) => {
                console.log(err);
            }
        });
};

export const getContactUsResponses = async (responseDispatch, prevList) => {
    let addedDocs = prevList;
    await firebase
        .firestore()
        .collection('contactus')
        .orderBy('submitOn', 'desc')
        .onSnapshot({
            next: (snapshot) => {
                addedDocs = snapshot.docs.map(e => e.data());
                responseDispatch({
                    type: contactUsResponsesActions.SET_RESPONSES,
                    resList: addedDocs,
                });
            }
        });
};

export const setGlobleAuthLoading = (value, globalDispatch) => {
    globalDispatch({
        type: globalActionTypes.SET_GLOBAL_AUTH_LOADING,
        globalLoading: value,
    });
};

export const setGlobalLoading = (value, globalDispatch) => {
    globalDispatch({
        type: globalActionTypes.SET_GLOBAL_LOADING,
        globalLoading: value,
    });
};

export const getSubscribers = async (subslistDispatch, prevList) => {
    return firebase
        .firestore()
        .collection('subscribers')
        .orderBy('date', 'asc')
        .onSnapshot({
            next: (snapshot) => {
                console.log(snapshot.docs.map(e => ({ id: e.id, ...e.data() })));
                let changes = snapshot.docChanges();
                let addedDocs = prevList;
                changes.forEach(change => {
                    if (change.type === 'added')
                        addedDocs.unshift({
                            id: change.doc.id,
                            ...change.doc.data()
                        });
                    else if (change.type === 'removed') {
                        addedDocs.filter(doc => doc.id !== change.doc.id);
                    }
                });
                subslistDispatch({
                    type: subsListActions.SET_SUBSLIST,
                    subList: addedDocs,
                });
            }
        });
};

